import { useState, useEffect } from 'react';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import dayjs from 'dayjs';

export default function CountdownModel({ groupActivityProductVO }) {
  let daysView = 0;
  let hoursView = 0;
  let minutesView = 0;
  let secondsView = 0;
  const [days, setDays] = useState(daysView);
  const [hours, setHours] = useState(hoursView);
  const [minutes, setMinutes] = useState(minutesView);
  const [seconds, setSeconds] = useState(secondsView);
  // const timer = null;

  const RefreshTime = () => {
    const targetDate = groupActivityProductVO?.groupEndTime || '2024-08-24 23:59:59';
    const nowTime = dayjs(dayjs().format('YYYY-MM-DD HH:mm:ss')).toDate();
    const end = dayjs(targetDate).toDate();
    const sec = dayjs(end).diff(dayjs(nowTime), 'second');
    if (sec < 0) {
      // clearInterval(time);
      // 清除定时器
      setDays(() => '00');
      setHours(() => '00');
      setMinutes(() => '00');
      setSeconds(() => '00');
      return;
    }
    daysView = Math.floor(sec / (60 * 60 * 24)).toString();
    hoursView = Math.floor((sec - daysView * 24 * 60 * 60) / 3600).toString();
    minutesView = Math.floor((sec - daysView * 24 * 60 * 60 - hoursView * 3600) / 60).toString();
    secondsView = Math.floor(sec - daysView * 24 * 60 * 60 - hoursView * 3600 - minutesView * 60).toString();
    setDays(() => daysView);
    setHours(() => hoursView);
    setMinutes(() => minutesView);
    setSeconds(() => secondsView);
  };

  useEffect(() => {
    RefreshTime();
    const timer = setInterval(() => {
      RefreshTime();
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <p className="flex items-center text-[16px] text-[#54657D]">
        <SvgIcon app="item" iconName="lt-clock" className="w-[16px] h-[16px]" />
        <p className="ml-[10px]">
          剩余
          <span className="text-[16px]">
            {/* {`${days}天${hours}小时${minutes}分${seconds}秒`} */}
            <span className="font-bold text-[#000]">{days}</span>天
            <span className="font-bold text-[#000]">{hours}</span>小时
            <span className="font-bold text-[#000]">{minutes}</span>分
            <span className="font-bold text-[#000]">{seconds}</span>秒
          </span>
          结束
        </p>
      </p>
      <div className="text-[14px] text-[#54657D] mt-[15px] leading-[24px]">
        <ul className="flex">
          <li className="flex-1">
            立推售价：<span className="text-[#FF4D4F]">￥{groupActivityProductVO?.groupPrice}</span>
          </li>
          <li className="flex-1">
            立推货期：
            <span className="text-[#000]">
              支付后{groupActivityProductVO?.productDeliveryDay - 1}-{groupActivityProductVO?.productDeliveryDay + 1}
              工作日
            </span>
          </li>
        </ul>
        <ul className="flex">
          <li className="flex-1">
            起订数量：<span className="text-[#000]">{groupActivityProductVO?.minBuyNumber}</span>
          </li>
          <li className="flex-1">
            剩余库存：
            <span className="text-[#000]">{groupActivityProductVO?.surplusRecommendNumber}</span>
          </li>
        </ul>
      </div>
    </>
  );
}
